export enum Languages {
    cs = "cs",
}
